export const INTRO_TO_CODING = "Intro to Coding";
export const INTRO_TO_SCRATCH = "Intro to Scratch";
export const SCRATCH = "Scratch";
export const WOOF = "Woof";
export const WEB = "Web";
export const PYTHON = "Python";
export const Algorithms = "Algorithms";
// export const STUDENT = "Student";
export const SCRATCHJR = "Scratch Jr.";
export const CODE4CHANGE = "Code 4 Change";
export const UNTUTORIALS = "Untutorials";
export const AI = "AI";
export const UNITY = "Unity";
export const DATA_SCIENCE = "Data Science";
export const ML_FOR_KIDS = "ML for Kids";
// export const DIGITAL_ART = "Digital Art";
// export const GAME_DESIGN = "Game Design";
export const ROBOTICS = "Robotics";
// export const ARTIFICIAL_INTELLIGENCE = "Artificial Intelligence";
